import styled from "styled-components";
import colours from "../../lib/colours";

export const SubHeading = styled.h4`
  margin-top: 16px;
  margin-bottom: 10px;
  font-weight: 600;
  color: ${colours.th1};
`;

export const Heading5 = styled.h5`
  margin-top: 10px;
  margin-bottom: 0px;
  font-size: 16px;
  font-weight: 300;
  color: ${colours.th1};
`;

export const Label = styled.div`
  margin-top: 16px;
  margin-bottom: 2px;
  text-decoration: underline;
  text-decoration-color: ${colours.th1l3alt};
  text-decoration-thickness: 2px;
  text-decoration-skip-ink: none;
  font-weight: 400;
`;

export const Value = styled.span`
  font-weight: 500;
  line-height: 22px;
`;
export const ValueNumber = styled.span`
  font-variant-numeric: tabular-nums;
  font-weight: 500;
`;

export const UnitSpan = styled.span`
  font-style: italic;
  margin-left: 4px;
`;
